export default __webpack_public_path__ + "static/media/img-2.b118fb21.jpg";